// extracted by mini-css-extract-plugin
export default {"input_with_btn":"Products_input_with_btn__I7JzI","dropzone_area":"Products_dropzone_area__6vzy+","dz_message_area":"Products_dz_message_area__5pOBK"};